import React from "react";
import Header from "./header";
import Footer from "./footer";
import Helmet from "react-helmet";
// @ts-ignore
import favicon16 from "../images/favicon-16x16.png";
// @ts-ignore
import favicon32 from "../images/favicon-32x32.png";
import Axios, {AxiosResponse} from "axios";

interface BlogItem {
	title: string;
	description: string;
	link: string;
	pubDay: string;
	pubMonth: string;
}

interface SonoBlogState {
	items: BlogItem[];
}


class SonoBlog extends React.Component<{}, SonoBlogState> {

	// static readonly months: string[] = ['OCA', 'ŞUB', 'MAR', 'NİS', 'MAY', 'HAZ', 'TEM', 'AĞU', 'EYL', 'EKİ', 'KAS', 'ARA'];
	static readonly months: string[] = ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'];

	constructor(props: {}) {
		super(props);
		this.state = {
			items: []
		}
	}

	componentWillMount(): void {
	}

	componentDidMount(): void {
		this.readPosts();
	}

	private async readPosts() {
		const response: AxiosResponse<XMLDocument> = await Axios.get<XMLDocument>("https://blog.sono.com.tr/feed/", {
			responseType: "document"
		});
		const document: XMLDocument = response.data;

		const xmlItems: HTMLCollectionOf<Element> = document.getElementsByTagName("item");
		const last: number = Math.min(xmlItems.length, 3);
		const items: BlogItem[] = [];

		let xmlItem: Element;
		let pubDate: Date;
		let day: number;

		for (let i = 0; i < last; i++) {
			xmlItem = xmlItems.item(i) as Element;
			pubDate = new Date(SonoBlog.readField(xmlItem, "pubDate"));
			day = pubDate.getDate();

			items.push({
				title: SonoBlog.readField(xmlItem, "title"),
				description: SonoBlog.parseDescription(SonoBlog.readField(xmlItem, "description")),
				link: SonoBlog.readField(xmlItem, "link"),
				pubDay: day < 10 ? '0' + day : day + '',
				pubMonth: SonoBlog.months[pubDate.getMonth()],
			});
		}

		this.setState({items});
	}

	private static readField(xmlItem: Element, fieldName: string): string {
		const field: Element = xmlItem.getElementsByTagName(fieldName).item(0) as Element;
		return field.textContent || "";
	}

	private static parseDescription(description: string): string {
		const el: Element = document.createElement('div');
		el.innerHTML = description;
		const items: HTMLCollectionOf<Element> = el.getElementsByTagName("p");

		if (items.length < 1)
			return "";
		else
			return (items.item(0) as Element).textContent || "";
	}

	render() {
		const {items} = this.state;

		return (
			<div className="blog container-fluid">
				<div className="container" style={{display: items.length ? 'block' : 'none'}}>
					<div className="row">
						<div className="col-12">
							<h1>Follow <span>SONO Enterprise Management Systems</span> Blog </h1>
						</div>
						<div className="col-12">
							<div className="row post-list">
								{items.map(item => (
									<div key={item.link} className="col-12 col-md-4 pt-5 pt-lg-0">
										<div className="blog-item">
											<div className="date">{item.pubDay}<br/><span>{item.pubMonth}</span></div>
											<div className="content">
												<h3>{item.title}</h3>
												<p>{item.description}</p>
												<a href={item.link}>READ MORE</a>
											</div>
										</div>
									</div>
								))}
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	}

}

interface LayoutProps {
	pageTitle?: string;
	className?: string;
	meta?: React.ReactNode,
	header?: React.ReactNode,
	body?: React.ReactNode
}

export default (props: LayoutProps) => (
	<div>
		<Helmet>
			<title>{props.pageTitle || "SONO GRC"}</title>

			<meta name="description"
				  content="SONO's Enterprise Management Systems (EMS) are integrated and modular software solutions that enable organizations to manage their strategic plans and its associated triple defense line (internal control, risk management-compliance, internal audit) in the most effective way, and support data and reporting with governance."/>
			<meta name="keywords"
				  content="Internal Control, Internal Control Software, Internal Audit, Internal Audit Software, Strategic Plan,  Strategic Plan Monitoring, Strategic Plan Evaluation, Strategic Planning, Strategic Planning Software, COSO, 5018, Risk Management, Internal Control and Risk Management, Risk Management Software, Internal Control and Risk Management Software, GRC, Risk Action Plan, Risk Matrix, Law No. 5018"/>
			<meta name="author" content="Sono Software Corp."/>
			<meta name="distribution" content="global"/>
			<meta name="language" content="English"/>
			<meta name="abstract" content="SONO Enterprise Management Systems (EMS)"/>
			<meta name="content-language" content="en-EN"/>
			<meta name="copyright" content="(c) 2015 Sono Software Corporation Ⓒ All rights reserved."/>
			<meta name="designer" content="SONO Software Corp."/>
			<meta name="robots" content="all"/>
			<meta name="theme-color" content="#235287"/>

			<link rel="icon" type="image/png" href={favicon16} sizes="16x16"/>
			<link rel="icon" type="image/png" href={favicon32} sizes="32x32"/>
			<link rel="shortcut icon" type="image/png" href={favicon32}/>

			<link rel="stylesheet" href="https://fonts.googleapis.com/css?family=Roboto:300,400,500,700,900"/>
			<link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.3.1/css/all.css"
				  integrity="sha384-mzrmE5qonljUremFsqc01SB46JvROS7bZs3IO2EmfFsd15uHvIt+Y8vEf7N7fWAU" crossOrigin="anonymous"/>

			{props.meta}

			<body className={props.className}/>
		</Helmet>

		<Header>{props.header}</Header>
		{props.body}
		{/*<SonoBlog/>*/}
		<Footer/>
	</div>
)
